module.exports = __webpack_public_path__ + "img/comp_check_24.08565cb6.svg";